import type { ReactNode } from "react";

const TONES = {
  admin: "border-dashed border-ink-2 bg-marker text-ink",
  free: "border-ink bg-ink text-paper",
};

export function Badge({ tone, children }: { tone: keyof typeof TONES; children: ReactNode }) {
  return (
    <span
      className={`inline-flex items-center gap-1 border px-1.5 py-px text-[10px] leading-tight font-bold tracking-wide whitespace-nowrap ${TONES[tone]}`}
    >
      {children}
    </span>
  );
}
